import React, {useState} from "react";
import {Button, Form} from "react-bootstrap";
import closeIcon from "../../../../assets/svg/actions/icn-close.svg";
import ModalBase from "../../modals/ModalBase";
import SVG from 'react-inlinesvg';

import '../../../../assets/sass/components/messages/create-group-modal.scss';

class CreateGroupModal extends ModalBase {

    state = {
        group_name: "",
    }

    onSubmit = (event) => {
        event.preventDefault();
        var {onSubmit} = this.props;
        if(onSubmit)
            onSubmit(event, this.state.group_name);
    }
    renderHeaderWrapper = () => {}
    renderFooterWrapper = () => {}
    renderBody = () => {
        return (
            <Form onSubmit={this.onSubmit}>
                <div className="d-flex justify-content-between align-items-center">
                    <h2>Create Group</h2>
                    <Button variant="link" className="close-modal" onClick={this.closeModal}><SVG src={closeIcon}/></Button>
                </div>

                <p>Please enter group name and select participants</p>

                <Form.Control name="text" placeholder="Group Name" className="input input-flat input-lg mt-3 mb-4 mt-1"
                  onInput={(e) => {this.setState({group_name: e.target.value})}}
                  value={this.state.group_name}
                />

                <Button type="submit" variant="primary" className="btn-lg btn-block" disabled={!this.state.group_name}>Create Group</Button>
            </Form>
        )
    }

    static defaultProps = {
        className: "create-group-modal",
        size: "md"
    };
};


export default CreateGroupModal;